import { getLegalMoves } from "../service/LegalMovesService";

export function validateMove(selectedPiece, pieces, blocks, x, y) {
    const selectedPieceLegalMoves = getLegalMoves(selectedPiece.x, selectedPiece.y, pieces, blocks);
    return selectedPieceLegalMoves.some(b => b.x === x && b.y === y)
}
export function selectPiece(state, x, y) {
    const piece = state.pieces.find(p => p.x === x && p.y === y)

    if (piece.playerType !== state.turn) return state;

    if (state.ongoingChainCapture) return;

    const legalMoves = getLegalMoves(x, y, state.pieces, state.blocks);

    const legalMovesSet = new Set(legalMoves.map(m => `${m.x},${m.y}`));
    const newPieces = state.pieces.map(p =>
        (p.x === x && p.y === y) && legalMoves.length > 0 ?
            { ...p, selected: true } : p)

    const highlightedBlocks = state.blocks.map(block => ({
        ...block,
        highlighted: legalMovesSet.has(`${block.x},${block.y}`),
    }))

    return {
        ...state,
        selectedPiece: piece,
        pieces: newPieces,
        blocks: highlightedBlocks,
    }
}

export function movePiece(state, x, y, paramSelectedPiece) {

    if (!paramSelectedPiece) {
        console.log('no selected piece');
        return state;
    }

    // Move the piece
    let newPieces = state.pieces.map(p => {
        return p.id === paramSelectedPiece.id ? { ...p, x: x, y: y } : p;
    });

    let capturedPiece = null;

    // Remove the captured piece
    // Look up Direction Vector + stepping
    const dx = Math.sign(x - paramSelectedPiece.x);
    const dy = Math.sign(y - paramSelectedPiece.y);

    let oldX = paramSelectedPiece.x + dx;
    let oldY = paramSelectedPiece.y + dy;

    // Walk from initial position upto the current position
    while (oldX !== x || oldY !== y) {
        const currX = oldX;
        const currY = oldY;

        const piece = newPieces.find(p => p.x === currX && p.y === currY);

        if (piece) {
            newPieces = newPieces.map(p =>
                p.id === piece.id ? { ...p, captured: true } : p
            );
            capturedPiece = piece;
            break;
        }

        oldX += dx;
        oldY += dy;
    }

    if (!capturedPiece) {// End current's player turn if there's no capture happen

        return {
            ...state,
            pieces: newPieces,
            ongoingChainCapture: false,
            selectedPiece: null,
        }
    }

    // Get legal moves with captured pieces filtered out
    newPieces = newPieces.filter(p => !p.captured);
    const captureMoves = getLegalMoves(x, y, newPieces, state.blocks, true);

    // setTimeout(() => {
    // newPieces = newPieces.filter(p => !p.captured)
    // }, 500);

    // If there's no more legal captures, return
    if (captureMoves?.length === 0) {

        return {
            ...state,
            pieces: newPieces,
            selectedPiece: null,
            ongoingChainCapture: false,
            capturedPieces: [...state.capturedPieces, capturedPiece],
        }
    }

    // Highlight new legal moves
    const legalMovesSet = new Set(captureMoves.map(m => `${m.x},${m.y}`));
    const newBlocks = state.blocks.map(block => ({
        ...block,
        highlighted: legalMovesSet.has(`${block.x},${block.y}`),
    }))

    newPieces = newPieces.map(p =>
        (p.id === paramSelectedPiece.id) ? { ...p, selected: true } : p
    )

    return {
        ...state,
        pieces: newPieces,
        blocks: newBlocks,
        selectedPiece: newPieces.find(p => p.id === paramSelectedPiece.id),
        ongoingChainCapture: true,
        capturedPieces: [...state.capturedPieces, capturedPiece],
    }
}

export function clearHighlights(state) {
    const newBlocks = state.blocks.map(b => ({ ...b, highlighted: false }))
    const newPieces = state.pieces.map(b => ({ ...b, selected: false }))

    return {
        ...state,
        blocks: newBlocks,
        pieces: newPieces
    }
}

export function checkForPromotion(state) {
    if (state.ongoingChainCapture) return state;

    const newPieces = state.pieces.map(piece => ({
        ...piece,
        promoted:
            (piece.promoted && !piece.captured) ||
            (piece.playerType === 'white' ? piece.y === 0 : piece.y === 7),
    }));

    return {
        ...state,
        pieces: newPieces
    }
}

export function checkForWin(state) {

    // Don't check during ongoing chain captures
    if (state.ongoingChainCapture) return state;

    if (state.pieces.length === 0) return state;

    const blackPieces = state.pieces.filter(p => p.playerType === "black");
    const whitePieces = state.pieces.filter(p => p.playerType === "white");

    // Check for piece elimination
    if (whitePieces.length === 0) {
        return {
            ...state,
            result: "black"
        }
    }

    if (blackPieces.length === 0) {
        return {
            ...state,
            result: "white"
        }
    }

    // Check if the NEXT player has no legal moves (they lose)
    const nextPlayerPieces = state.turn === "white" ? blackPieces : whitePieces;
    const nextPlayerHasLegalMoves = nextPlayerPieces.some(piece => {
        const moves = getLegalMoves(piece.x, piece.y, state.pieces, state.blocks);
        return moves.length > 0;
    });

    // If the next player has no legal moves and current player does. Current player wins
    if (!state.ongoingChainCapture && !nextPlayerHasLegalMoves) {
        return {
            ...state,
            result: state.turn
        }
    }

    return state;
}

export function changeTurn(state) {
    const turn = state.ongoingChainCapture
        ? state.turn
        : (state.turn === "white" ? "black" : "white");

    return {
        ...state,
        turn: turn
    }
}

export function updateMoveHistory(state, stateSnapshot) {
    return {
        ...state,
        moveHistory: [...state.moveHistory, stateSnapshot]
    }
}